<template>
    <div id="delete-operation-dialog-component">
        <v-dialog v-model="is_delete_operation_dialog_open" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">{{ $t('asset_operations_datatable_widget_component.delete_operation') }}</span>
                </v-card-title>
                <v-card-text class="pb-0 error--text">
                    {{ $t('asset_operations_datatable_widget_component.will_delete_operation') }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="is_delete_operation_dialog_open = false">{{ $t('global.cancel') }}</v-btn>
                    <v-btn :loading="deleting_operation" color="error" elevation="0" rounded @click="deleteOperation">
                        <span class="white--text">{{ $t('global.delete') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AssetRepository from '@/repositories/AssetRepository'

export default {
    name: 'DeleteOperationDialogComponent',
    data() {
        return {
            is_delete_operation_dialog_open: false,
            deleting_operation: false,
            operation: {},
        }
    },
    methods: {
        openDeleteOperationDialog(operation) {
            this.operation = operation
            this.is_delete_operation_dialog_open = true
        },
        deleteOperation() {
            this.deleting_operation = true
            AssetRepository.deleteOperation(this.operation.id_operation)
                .then(() => {
                    this.is_delete_operation_dialog_open = false
                    this.showSnackbar('success', this.$t('asset_operations_datatable_widget_component.operation_deleted'))
                    this.$emit('deleted:operation')
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.deleting_operation = false
                })
        },
    },
}
</script>
